import { NestedSearchWithObjects } from "@habity/types";
import { getCategoryText } from "../addresses";
import slugify from 'slugify';
import { ROUTES } from "@habity/constants";

export const getSpeculatorSlug = (search: Partial<NestedSearchWithObjects>) => {
  const {
    id,
    categories,
    rooms_min,
    rooms_max,
    living_space_min,
    living_space_max,
    municipalities,
    areas
  } = search || {};
  if (!id) return '';

  // Build slug out of parts
  const categoryPart = categories && categories.length > 0 ? getCategoryText(categories[0]) : '';
  const municipalityPart = municipalities && municipalities.length > 0 ? `-${municipalities[0].name}-kommun` : '';
  const areaPart = areas && areas.length > 0 ? `-${areas[0].name}` : '';
  const roomsPart = rooms_min && rooms_max ? `-${rooms_min}-${rooms_max}rum` :
    rooms_min ? `-${rooms_min}rum` :
      rooms_max ? `-${rooms_max}rum` : '';
  const livingSpacePart = living_space_min && living_space_max ? `-${living_space_min}-${living_space_max}m2` :
    living_space_min ? `-${living_space_min}m2` :
      living_space_max ? `-${living_space_max}m2` : '';

  return slugify(
    `${categoryPart}${roomsPart}${livingSpacePart}${areaPart}${municipalityPart}-${id}`
  );
};

export const getSpeculatorPath = (search: NestedSearchWithObjects) => {
  return ROUTES.PROFILES.SPECULATORS + getSpeculatorSlug(search);
};
